import { render } from "./vTextArea.vue?vue&type=template&id=4bacf4c7&scoped=true"
import script from "./vTextArea.vue?vue&type=script&lang=js"
export * from "./vTextArea.vue?vue&type=script&lang=js"

import "./vInput.less?vue&type=style&index=0&id=4bacf4c7&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bacf4c7"]])

export default __exports__